/**************************************************
 * Nombre:       Boton
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button} from "@mui/material";

const Boton = ({texto, click}) => {

    return (
        <Button
            onClick={() => click()}
            color={'secondary'}
            sx={{borderLeft: 2, borderColor: '#fff'}}
        >
            {texto}
        </Button>
    )

}
export default Boton